// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-cart-line-comment',
    // #endregion
    // #region Mixins
    mixins: [host.mixins.modal],
    // #endregion
    // #region Properties
    props: {
        cartID: {
            type: String,
            required: false,
            default: ''
        },
        lineID: {
            type: String,
            required: false,
            default: ''
        },
        comment: {
            type: String,
            required: false,
            default: ''
        },
        line: {
            type: Object,
            required: false,
            default: null
        },
    },
    // #endregion
    // #region Properties
    data: () => ({
        _comment: '',
        _loading: false
    }),
    // #endregion
    // #region Boostrap
    created() {
        this._comment = this.comment;
    },
    // #endregion
    // #region Methods
    methods: {
        onSave() {
            // #region Check
            if (this._loading) {
                return;
            }
            // #endregion
            // #region Args
            let tData = {
                comment: this._comment
            };
            // #endregion
            // #region Send
            //Run
            this._loading = true;
            //data
            host.api.patch(`commerce/checkout/${this.cartID}/lines/${this.lineID}`, tData)
                .then(e => {
                // #region Internal
                if (e.data?.cart) {
                    this.line.comment = tData.comment;
                }
                // #endregion
                // #region Loading
                this._loading = false;
                // #endregion
                // #region Close
                this.currentWindow.close();
                // #endregion
            })
                .catch(e => {
                // #region Data
                host.notification.showToast(utils.getAxiosErrorMessage(e), "error");
                // #endregion
                // #region Loading
                this._loading = false;
                // #endregion
            });
            // #endregion
        }
    }
    // #endregion
});
// #endregion
